import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import {
  getApiBaseUrl,
  ADD_ACTIVITY,
  LOGIN,
  GET_LOCATIONS,
} from "../../../Config/Config";
import { Select } from "antd";


const FilterTreeEditFilterModel = ({
  onClose,
  blockName,
  blockId,
  areaName,
  areaId,
  // ahuid,
  // ahuName,
  filterData,
  onSuccess,
}) => {
  // console.log(ahuid);
  // console.log(ahuName, "eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee");

  // console.log(filterData, "oooooooooooooo");

  // console.log(areaId);

  const [blocks, setBlocks] = useState([]);
  const [areas, setAreas] = useState([]);

  const [selectedBlockId, setSelectedBlockId] = useState(null);
  const [selectedAreaId, setSelectedAreaId] = useState(null);
  const [selectedAhuId, setSelectedAhuId] = useState(null);

  const [loadingBlocks, setLoadingBlocks] = useState(false);
  const [loadingAreas, setLoadingAreas] = useState(false);

  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const [loading, setLoading] = useState(false);
  console.log(loading);
  const [authLoading, setAuthLoading] = useState(false);
  const [askPassword, setAskPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  console.log(error);

  const [filterId, setFilterId] = useState("");
  const [filterSize, setFilterSize] = useState("");
  const [filterDimensions, setFilterDimensions] = useState("");
  const [selectedFilterType, setSelectedFilterType] = useState(undefined);
  const [filterTypes, setFilterTypes] = useState([]);

  const [AHU, setAHU] = useState([]);
  const [editAhuId, setEditAhuId] = useState(null);

  const [currentStatus, setCurrentStatus] = useState("");
  const [label, setLabel] = useState("");

  const fetchBlocks = async () => {
    setLoadingBlocks(true);
    try {
      const res = await fetch(`${getApiBaseUrl()}${GET_LOCATIONS}`);
      const data = await res.json();
      setBlocks(data?.ResultData || []);
    } catch (err) {
      console.error("Block fetch error", err);
    } finally {
      setLoadingBlocks(false);
    }
  };

  const fetchAreas = async (blockId) => {
    if (!blockId) return;
    setLoadingAreas(true);
    try {
      const res = await fetch(
        `${getApiBaseUrl()}/Areas/getblockareas?BlockId=${blockId}`,
      );
      const data = await res.json();
      setAreas(data?.ResultData || []);
    } catch (err) {
      console.error("Area fetch error", err);
    } finally {
      setLoadingAreas(false);
    }
  };

  const fetchAHU = async (blockId, areaId) => {
    try {
      const response = await fetch(
        `${getApiBaseUrl()}/ahuph2/getahu?BlockId=${blockId}&AreaId=${areaId}`,
      );
      const result = await response.json();
      setAHU(result?.ResultData || []);
    } catch (error) {
      console.error("Error fetching blocks:", error);
    }
  };

  const fetchFilterTypes = async () => {
    try {
      const res = await fetch(`${getApiBaseUrl()}/api/getFilterType`);
      if (!res.ok) throw new Error("Failed to fetch filter types");
      const data = await res.json();
      if (data?.Status) {
        setFilterTypes(data.ResultData);
      } else {
        console.error("Error in API response:", data);
        setFilterTypes([]);
      }
    } catch (err) {
      console.error("Network error:", err);
      setFilterTypes([]);
    }
  };

  const handleSave = async () => {
    const logActivity = async (isSuccess, notes) => {
      try {
        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ActivityType: 1,
            PerformedBy: user?.UserID,
            PerformedOn: new Date()
              .toISOString()
              .slice(0, 19)
              .replace("T", " "),
            Notes: notes,
            Location: "addAHU",
            IsSucces: isSuccess ? 1 : 0,
          }),
        });
      } catch (err) {
        console.error("Failed to log activity:", err);
      }
    };

    const payload = {
      Id: filterData.Id,
      AHUId: selectedAhuId,
      AssetType: selectedFilterType,
      Location: selectedBlockId,
      Dimensions: filterDimensions,
      MicronRating: filterSize,
      CurrentStatus: currentStatus,
      Lable: label,
      Status: filterData.Status,
      LastCleaningDate: filterData.LastCleaningDate,
      updatedby: user?.UserID,
      Loctypeid: filterData.LocationTypeid,
    };

    console.log(payload, "payload");

   try {
  setLoading(true);

  const response = await fetch(
    `${getApiBaseUrl()}/filterph2/updatefilter`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );

  const result = await response.json();

  console.log("Update filter full response:", result); 

 
  const innerResult = result?.ResultData?.[0];
  const innerStatus = innerResult?.Status;
  const errorMessage =
    innerResult?.ResultMessage ||
    result?.message ||
    result?.Message ||
    "Unknown error from server";

  
  if (response.ok && innerStatus === "Success") {
    await logActivity(
      true,
      `Filter "${filterId}" updated successfully for Block "${blockName}", Area "${areaName}"`
    );

    Swal.fire({
      icon: "success",
      title: "Success",
      text: "Filter updated successfully!",
      timer: 1500,
      showConfirmButton: false,
    }).then(() => {
      onSuccess(); 
      onClose();  
    });
  } else {
    
    console.error("Update failed - inner status:", innerStatus, "message:", errorMessage);

    await logActivity(
      false,
      `Failed to update filter "${filterId}" for Block "${blockName}", Area "${areaName}": ${errorMessage}`
    );

    Swal.fire({
      icon: "error",
      title: "Update Failed",
      text: errorMessage,
    });
  }
} catch (error) {
  console.error("Network or unexpected error during update:", error);

  await logActivity(
    false,
    `Network error while updating filter "${filterId}": ${error.message || "Unknown error"}`
  );

  Swal.fire({
    icon: "error",
    title: "Error",
    text: "Unable to connect to server or unexpected error occurred.",
  });
} finally {
  setLoading(false);
  setAskPassword(false);
  setPassword("");
  setError("");
}
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      // !filterId ||
      !filterSize ||
      !filterDimensions ||
      !selectedFilterType
    ) {
      Swal.fire(
        "Validation Error",
        "Please fill all required fields",
        "warning",
      );
      return;
    }

    setAskPassword(true);
  };
  const handleAuth = async () => {
    if (!password) {
      setError("Please enter your password.");
      return;
    }

    setAuthLoading(true);
    setError("");

    try {
      if (!user?.UserName) {
        throw new Error("User name not found in session data.");
      }

      const payload = {
        username: user.UserName,
        password,
      };

      const res = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.status) {
        setAskPassword(false);
        setPassword("");
        await handleSave();
      } else {
        throw new Error(
          data.Message || "Invalid credentials. Please try again.",
        );
      }
    } catch (err) {
      setError(err.message || "Unable to authenticate. Please try again.");
    } finally {
      setAuthLoading(false);
    }
  };

  useEffect(() => {
    fetchFilterTypes();
  }, []);

  useEffect(() => {
    if (filterData) {
      console.log("Editing AHU:", filterData);
    }
  }, [filterData]);

  useEffect(() => {
    if (!filterData) return;

    setSelectedBlockId(filterData.Location);
    setEditAhuId(filterData.AHUId);

    setSelectedFilterType(filterData.AssetType || null);
    setFilterDimensions(filterData.Dimensions || "");
    setFilterSize(filterData.MicronRating || "");
    setFilterId(filterData.Lable || "");

    setCurrentStatus(filterData.CurrentStatus || "");
    setLabel(filterData.Lable || "");
    // setLocTypeId(filterData.LocationTypeid || null);
  }, [filterData]);

  useEffect(() => {
    if (!filterData) {
      filterId("");
      filterSize("");
      setFilterTypes("");
      filterDimensions("");
    }
  }, [filterData]);

  useEffect(() => {
    fetchBlocks();
    // fetchAHU();
  }, []);

  useEffect(() => {
    if (blocks.length && blockId) {
      setSelectedBlockId(blockId);
    }
  }, [blocks, blockId]);

  useEffect(() => {
    if (selectedBlockId) {
      fetchAreas(selectedBlockId);
      // setSelectedAreaId(null);
      // setSelectedAhuId(null);
    }
  }, [selectedBlockId]);

  useEffect(() => {
    if (areas.length && areaId) {
      setSelectedAreaId(areaId);
      fetchAHU(blockId, areaId);
    }
  }, [areas, areaId]);

  useEffect(() => {
    if (editAhuId && AHU.length) {
      setSelectedAhuId(editAhuId);
      setEditAhuId(null); // cleanup
    }
  }, [AHU, editAhuId]);

  useEffect(() => {
    if (selectedBlockId && selectedAreaId) {
      fetchAHU(selectedBlockId, selectedAreaId);
      setSelectedAhuId(null); // reset on user area change
    }
  }, [selectedBlockId, selectedAreaId]);

  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block", zIndex: 1055 }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Filter</h5>
              <button
                type="button"
                onClick={onClose}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: "22px",
                  fontWeight: "bold",
                  lineHeight: "1",
                  cursor: "pointer",
                }}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label">Block</label>
                  <Select
                    style={{ width: "100%" }}
                    getPopupContainer={(triggerNode) =>
                      triggerNode.parentElement
                    }
                    placeholder="Select Block"
                    value={selectedBlockId}
                    loading={loadingBlocks}
                    onChange={(value) => {
                      setSelectedBlockId(value);
                      setSelectedAreaId(null); // ✅ reset ONLY on user action
                      setAreas([]);
                    }}
                    options={blocks.map((b) => ({
                      value: b.BlockId,
                      label: b.BlockName,
                    }))}
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Area</label>
                  <Select
                    style={{ width: "100%" }}
                    getPopupContainer={(triggerNode) =>
                      triggerNode.parentElement
                    }
                    placeholder="Select Area"
                    value={selectedAreaId}
                    loading={loadingAreas}
                    disabled={!selectedBlockId}
                    onChange={(value) => setSelectedAreaId(value)}
                    options={areas.map((a) => ({
                      value: a.Areaid,
                      label: a.AreaName,
                    }))}
                  />
                </div>
                
                <div className="col-md-4 mb-3">
                  <label className="form-label">Filter Type / Category</label>
                  <Select
                    showSearch
                    placeholder="Select Filter Type"
                    value={selectedFilterType ?? undefined}
                    onChange={(value) => setSelectedFilterType(value)}
                    className="w-100"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option?.children
                        ?.toString()
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    disabled={askPassword}
                    getPopupContainer={(triggerNode) =>
                      triggerNode.parentElement
                    }
                  >
                    {filterTypes.map((item) => (
                      <Select.Option key={item.Id} value={item.Id}>
                        {item.AssetType}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">AHU</label>
                  <Select
                    style={{ width: "100%" }}
                    placeholder="Select AHU"
                    value={selectedAhuId}
                    disabled={!selectedAreaId}
                    onChange={(value) => setSelectedAhuId(value)}
                    getPopupContainer={(triggerNode) =>
                      triggerNode.parentElement
                    }
                  >
                    {AHU.map((ahu) => (
                      <Select.Option key={ahu.ID} value={ahu.ID}>
                        {ahu.Code}
                      </Select.Option>
                    ))}
                  </Select>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Filter Label *</label>
                  <input
                    type="text"
                    className="form-control"
                    value={label}
                    onChange={(e) => setLabel(e.target.value)}
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label">Filter Size (Micron)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={filterSize}
                    onChange={(e) => setFilterSize(e.target.value)}
                  />
                </div>


                <div className="col-md-4 mb-3">
                  <label className="form-label">Filter Dimensions</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="L x W x H"
                    value={filterDimensions}
                    onChange={(e) => setFilterDimensions(e.target.value)}
                  />
                </div>
                <div className="col-md-4 mb-3 d-none">
                  <label className="form-label">Current Status</label>
                  <Select
                    value={currentStatus}
                    onChange={setCurrentStatus}
                    className="w-100"
                    getPopupContainer={(triggerNode) =>
                      triggerNode.parentElement
                    }
                  >
                    <Select.Option value="Running">Running</Select.Option>
                    <Select.Option value="Stopped">Stopped</Select.Option>
                  </Select>
                </div>
              </div>
              {askPassword && (
                <div className="mt-2">
                  <div className="mb-3 w-lg-75 col-4">
                    <label className="form-label">
                      Confirm Password <span className="text-danger"> *</span>
                    </label>
                    <div className="pass-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        className="pass-input form-control"
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          setError("");
                        }}
                        onCopy={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                        onCut={(e) => e.preventDefault()}
                        placeholder="Enter Password"
                      />
                      <span
                        className={`ti toggle-password ${
                          showPassword ? "ti-eye" : "ti-eye-off"
                        }`}
                        onClick={() => setShowPassword(!showPassword)}
                      ></span>
                    </div>
                  </div>
                  <button
                    className="btn btn-primary btn-sm me-2"
                    onClick={handleAuth}
                    disabled={authLoading || !password}
                  >
                    {authLoading ? "Verifying..." : "Confirm"}
                  </button>
                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => {
                      setAskPassword(false);
                      setPassword("");
                      setError("");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
            {!askPassword && (
              <div className="modal-footer gap-2">
                <button className="btn btn-secondary" onClick={onClose}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handleSubmit}>
                  Save
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1050 }}
        onClick={onClose}
      />
    </>
  );
};

FilterTreeEditFilterModel.propTypes = {
  onClose: PropTypes.func.isRequired,

  blockName: PropTypes.string,
  blockId: PropTypes.number,

  areaName: PropTypes.string,
  areaId: PropTypes.number,

  ahuid: PropTypes.number,
  ahuName: PropTypes.string,
  onSuccess: PropTypes.string,

  filterData: PropTypes.shape({
    Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    // Lable:PropTypes.oneOfType([PropTypes.string,PropTypes.number]).isRequired,
    AHUId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    AssetType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Location: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Dimensions: PropTypes.string,
    MicronRating: PropTypes.string,
    CurrentStatus: PropTypes.string,
    Lable: PropTypes.string,
    LastCleaningDate: PropTypes.string,
    Status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    updatedby: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    LocationTypeid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
};

export default FilterTreeEditFilterModel;
